import React from "react";
import Chat from "../../../../../../JsonScreen/Screen/ScreenComponents/Chat";

const ChatComponent = () => {
    return (
        <Chat
            properties={{}}
            styles={[{width: '100%', height: '100%'}]}
        />
    )
};

export default ChatComponent;